import React from "react";
import ReactDOM from "react-dom";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "./frontend.scss";

const divsToUpdate = document.querySelectorAll(".splide_element");

divsToUpdate.forEach(function (div) {
  const data = JSON.parse(div.querySelector("pre").innerHTML);
  ReactDOM.render(<Slider {...data} />, div);
  div.classList.remove("splide_element");
});

function Slider(props) {
  // Don't show empty items
  props.images = props.images.filter(function (image) {
    return image.id > 0;
  });
  return (
    <Splide
      options={{
        type: slider_options.type,
        rewind: slider_options.rewind,
        heightRatio: slider_options.height_ratio,
        gap: slider_options.gap + "px",
        padding: slider_options.padding + "%",
        breakpoints:
          slider_options.breakpoint == ""
            ? ""
            : {
                [slider_options.breakpoint]: {
                  rewind: slider_options.rewind,
                  type: slider_options.type,
                  heightRatio: slider_options.breakpoint_height_ratio,
                  gap: slider_options.breakpoint_gap + "px",
                  padding: slider_options.breakpoint_padding + "%",
                },
              },
      }}
    >
      {props.images.map((image) => {
        return (
          <SplideSlide>
            <a className="foobox" rel="gallery" href={image.front_url}>
              <img src={image.front_url} alt="" />
            </a>
          </SplideSlide>
        );
      })}
    </Splide>
  );
}
